import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BlockCipherMode } from './cipher-core.js';

function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
  var _words = words;
  var keystream; // Shortcut

  var iv = this._iv; // Generate keystream

  if (iv) {
    keystream = iv.slice(0); // Remove IV for subsequent blocks

    this._iv = undefined;
  } else {
    keystream = this._prevBlock;
  }

  cipher.encryptBlock(keystream, 0); // Encrypt

  for (var i = 0; i < blockSize; i += 1) {
    _words[offset + i] ^= keystream[i];
  }
}
/**
 * Cipher Feedback block mode.
 */


export var CFB = /*#__PURE__*/function (_BlockCipherMode) {
  _inherits(CFB, _BlockCipherMode);

  var _super = _createSuper(CFB);

  function CFB() {
    _classCallCheck(this, CFB);

    return _super.apply(this, arguments);
  }

  return _createClass(CFB);
}(BlockCipherMode);

CFB.Encryptor = /*#__PURE__*/function (_CFB) {
  _inherits(_class, _CFB);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      // Shortcuts
      var cipher = this._cipher;
      var blockSize = cipher.blockSize;
      generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // Remember this block to use with next block

      this._prevBlock = words.slice(offset, offset + blockSize);
    }
  }]);

  return _class;
}(CFB);

CFB.Decryptor = /*#__PURE__*/function (_CFB2) {
  _inherits(_class2, _CFB2);

  var _super3 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super3.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      // Shortcuts
      var cipher = this._cipher;
      var blockSize = cipher.blockSize; // Remember this block to use with next block

      var thisBlock = words.slice(offset, offset + blockSize);
      generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // This block becomes the previous block

      this._prevBlock = thisBlock;
    }
  }]);

  return _class2;
}(CFB);